import * as geom from "js/core/utilities/geom";

import { OrgChartNode } from "./OrgChartNode";

export class HiddenOrgChartRootNode extends OrgChartNode {
    _calcProps(props, options) {
        return { size: new geom.Size(0, 0) };
    }
}
